import React from 'react'
import { Modal, Grid, TextField, Typography, Button, CircularProgress, IconButton, useTheme, useMediaQuery } from '@material-ui/core'
import ClearIcon from '@material-ui/icons/Clear'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { useHistory } from 'react-router-dom'
import Cookie from 'js-cookie'
import { useStore } from '../../context/Context'
import useStyles from './styles'
import { login } from '../../api'

const LoginForm = () => {
  const classes = useStyles()
  const history = useHistory()
  const theme = useTheme()
  const matchXS = useMediaQuery(theme.breakpoints.down('xs'))
  const {
    openModal,
    setOpenModal,
    setSignUpMode,
    isLoading,
    setIsLoading,
    setIsLogin,
    setMessage,
    setSelectedTab,
    setSelectedDrawer
  } = useStore()
  const { handleSubmit, getFieldProps, errors, touched } = useFormik({
    initialValues: {
      email: '',
      password: ''
    },
    validationSchema: Yup.object({
      email: Yup.string().required('This field is a must!').email('This field is email formatted!'),
      password: Yup.string().required('This field is a must!').min(8),
    }),
    onSubmit: async (values, actions) => {
      setIsLoading(true)
      try {
        const { email, password } = values
        const { data } = await login(email, password)
        await Cookie.set('name', data.user.name, { expires: 1 })
        await Cookie.set('email', data.user.email, { expires: 1 })
        await Cookie.set('token', data.token, { expires: 1 })
        actions.resetForm()
        setMessage(state => ({
          ...state,
          msg: 'Logged in',
          severty: 'success',
          open: true
        }))
        setOpenModal(false)
        setIsLogin(true)
        setSelectedTab(false)
        setSelectedDrawer(0)
        history.push('/dashboard')
      } catch (error) {
        console.log(error)
        setMessage(state => ({
          ...state,
          msg: 'Email or Password is incorrect!',
          severty: 'error',
          open: true
        }))
        setOpenModal(false)
        setIsLoading(false)
      }
    }
  })

  const handleClose = () => {
    setSignUpMode(false)
    setOpenModal(false)
  }

  return (
    <Modal
      open={openModal}
      onClose={handleClose}
      aria-labelledby="login modal"
      aria-describedby="login modal for user sign in"
      className={classes.modal}
    >
      <form onSubmit={handleSubmit} autoComplete="off">
        <Grid container direction="column" justifyContent="center" alignItems="center" style={{ top: '50%', left: '50%', transform: `translate(-50%, -50%)`, width: matchXS ? '90%' : '100%' }} className={classes.paper} >
          {isLoading ? (
            <Grid item container justifyContent="center" alignItems="center" className={classes.loading}>
              <CircularProgress />
            </Grid>
          ) : (
            <>
              <div style={{ position: 'absolute', top: 3, right: 3 }}>
                <IconButton onClick={handleClose}>
                  <ClearIcon style={{ color: 'white' }} />
                </IconButton>
              </div>
              <Grid item style={{ marginBottom: theme.spacing(3) }}>
                <Typography variant="h4">Login Form</Typography>
              </Grid>
              <Grid item container direction="column" spacing={3}>
                <Grid item>
                  <TextField
                    variant="outlined"
                    name="email"
                    label="Email"
                    {...getFieldProps('email')}
                    fullWidth
                    classes={{ root: classes.input }}
                  />
                  {touched.email && errors.email ? <Typography variant="caption" color="error">{errors.email}</Typography> : null}
                </Grid>
                <Grid item>
                  <TextField
                    variant="outlined"
                    name="password"
                    type="password"
                    label="Password"
                    {...getFieldProps('password')}
                    fullWidth
                    classes={{ root: classes.input }}
                  />
                  {touched.password && errors.password ? <Typography variant="caption" color="error">{errors.password}</Typography> : null}
                </Grid>
                <Grid item container direction={matchXS ? 'column' : 'row'} spacing={3}>
                  <Grid item>
                    <Button variant="contained" type="submit" color="primary" className={`${classes.button} ${classes.buttonLogin}`} fullWidth={matchXS}>Log me in</Button>
                  </Grid>
                  <Grid item>
                    <Button variant="outlined" color="primary" className={classes.button} onClick={() => setSignUpMode(true)} fullWidth={matchXS}>Create account</Button>
                  </Grid>
                </Grid>
              </Grid>
            </>
          )}
        </Grid>
      </form>
    </Modal>
  )
}

export default LoginForm
